import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin({
  name: 'sentry',
  parallel: true,
  setup(nuxtApp) {
    const { public: { sentry } } = useRuntimeConfig();

    if (!sentry.dsn) {
      return;
    }

    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: sentry.dsn,
      environment: sentry.environment,
      ignoreErrors: [
        'Importing a module script failed.',
      ],
    });
  },
});
